module.exports = __webpack_public_path__ + "static/media/hengshan_plant.c7a6d9b8.webp";